export default __webpack_public_path__ + "static/media/candymuseum.a41600a3.PNG";